import styled from 'styled-components';
import {theme} from '@styles/theme';

export const ModalWrapper = styled.div`
  width: 432px;
`;

export const ModalContent = styled.div`
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  gap: 24px;
  padding: 24px;
  justify-content: center;
  border-top: 1px solid ${theme.colors.basic06};
  button {
    width: 50%;
  }
`;

export const OptionsGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const OptionsRow = styled.div`
  display: flex;
  gap: 16px;
`;

export const HeaderInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const DateRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  color: ${theme.colors.basic02};
`;

export const SectionCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px;
  background-color: ${theme.colors.basic07};
  border-radius: ${theme.roundedMedium};
`;

export const SecondarySectionCard = styled(SectionCard)`
  background-color: ${theme.colors.basic06};
  border-radius: 0 0 ${theme.roundedMedium} ${theme.roundedMedium};
  padding-left: 32px;
`;

export const SectionWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const CopyLinkWrapper = styled.div`
  background-color: ${theme.colors.accent02};
  border-radius: ${theme.roundedMedium};
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2px 8px;
  button {
    font-weight: 400;
  }
`;

export const NoticeRow = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  margin-top: 8px;
`;

export const NoticeIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  border-radius: 56px;
  background-color: ${theme.colors.basic08};
  border: 1px solid ${theme.colors.basic06};
`;
